<template>
	<v-dialog v-model="showDialog" :max-width="maxWidth">
		<v-card :tile="$vuetify.breakpoint.xs" id="card" class="large-process-dialog">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">工程時間変更</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2 mt-4">
				<template v-if="!largeProcessType.schedule_arrangement_flag">
					<v-row no-gutters>
						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="工程開始予定日(生産企画)"
										:rules="largeProcess.planned_start_time ? [rules.required] : []"
										:hint="
											largeProcess.planned_start_time
												? '工程開始予定時刻がある場合は日付も入力が必要です。'
												: ''
										"
										:persistent-hint="
											largeProcess.planned_start_time != null && !largeProcess.planned_start_date
										"
										v-model="largeProcess.planned_start_date"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker
									v-model="largeProcess.planned_start_date"
									no-title
									scrollable
									locale="ja"
								/>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-text-field
								v-model="largeProcess.planned_start_time"
								label="工程開始予定時刻(生産企画)"
								class="mt-4"
								type="time"
								step="1800"
								outlined
								dense
							/>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="工程完了予定日(生産企画)"
										:rules="largeProcess.planned_end_time ? [rules.required] : []"
										:hint="
											largeProcess.planned_end_time
												? '工程完了予定時刻がある場合は日付も入力が必要です。'
												: ''
										"
										:persistent-hint="
											largeProcess.planned_end_time != null && !largeProcess.planned_end_date
										"
										v-model="largeProcess.planned_end_date"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker
									v-model="largeProcess.planned_end_date"
									no-title
									scrollable
									locale="ja"
								/>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-text-field
								v-model="largeProcess.planned_end_time"
								label="工程完了予定時刻(生産企画)"
								class="mt-4"
								type="time"
								step="1800"
								outlined
								dense
							/>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="工程開始予定日(製造)"
										:rules="largeProcess.schedule_start_time ? [rules.required] : []"
										:hint="
											largeProcess.schedule_start_time
												? '工程開始予定時刻がある場合は日付も入力が必要です。'
												: ''
										"
										:persistent-hint="
											largeProcess.schedule_start_time != null && !largeProcess.schedule_start_date
										"
										v-model="largeProcess.schedule_start_date"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker
									v-model="largeProcess.schedule_start_date"
									no-title
									scrollable
									locale="ja"
								/>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-text-field
								v-model="largeProcess.schedule_start_time"
								label="工程開始予定時刻(製造)"
								class="mt-4"
								type="time"
								step="1800"
								outlined
								dense
							/>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="工程完了予定日(製造)"
										:rules="largeProcess.schedule_end_time ? [rules.required] : []"
										:hint="
											largeProcess.schedule_end_time
												? '工程完了予定時刻がある場合は日付も入力が必要です。'
												: ''
										"
										:persistent-hint="
											largeProcess.schedule_end_time != null && !largeProcess.schedule_end_date
										"
										v-model="largeProcess.schedule_end_date"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker
									v-model="largeProcess.schedule_end_date"
									no-title
									scrollable
									locale="ja"
								/>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-text-field
								v-model="largeProcess.schedule_end_time"
								label="工程完了予定時刻(製造)"
								class="mt-4"
								type="time"
								step="1800"
								outlined
								dense
							/>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="工程開始日"
										:rules="largeProcess.start_time ? [rules.required] : []"
										:hint="
											largeProcess.start_time
												? '工程開始時刻がある場合は日付も入力が必要です。'
												: ''
										"
										:persistent-hint="largeProcess.start_time != null && !largeProcess.start_date"
										v-model="largeProcess.start_date"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker v-model="largeProcess.start_date" no-title scrollable locale="ja" />
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-text-field
								v-model="largeProcess.start_time"
								label="工程開始時刻"
								class="mt-4"
								type="time"
								step="1800"
								outlined
								dense
							/>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="工程完了日"
										:rules="largeProcess.end_time ? [rules.required] : []"
										:hint="
											largeProcess.end_time ? '工程完了時刻がある場合は日付も入力が必要です。' : ''
										"
										:persistent-hint="largeProcess.end_time != null && !largeProcess.end_date"
										v-model="largeProcess.end_date"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker v-model="largeProcess.end_date" no-title scrollable locale="ja" />
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-text-field
								v-model="largeProcess.end_time"
								label="工程完了時刻"
								class="mt-4"
								type="time"
								step="1800"
								outlined
								dense
							/>
						</v-col>
					</v-row>
				</template>
				<template v-else>
					<v-row no-gutters>
						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										:label="`${largeProcessType.name}実行想定範囲(開始)`"
										:rules="[rules.required]"
										v-model="scheduleArrangementEstimatedStartDate"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker
									v-model="scheduleArrangementEstimatedStartDate"
									no-title
									scrollable
									locale="ja"
								/>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										:label="`${largeProcessType.name}実行想定範囲(終了)`"
										:rules="[rules.required]"
										v-model="scheduleArrangementEstimatedEndDate"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker
									v-model="scheduleArrangementEstimatedEndDate"
									no-title
									scrollable
									locale="ja"
								/>
							</v-menu>
						</v-col>

						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										:label="`${largeProcessType.name}実行予定日(開始)`"
										:rules="[rules.required]"
										v-model="scheduleArrangementPlannedStartDate"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker
									v-model="scheduleArrangementPlannedStartDate"
									no-title
									scrollable
									locale="ja"
								/>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-text-field
								v-model="scheduleArrangementPlannedStartTime"
								:label="`${largeProcessType.name}実行予定時間(開始)`"
								:rules="[rules.required]"
								class="mt-4"
								type="time"
								step="1800"
								outlined
								dense
							/>
						</v-col>
						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										:label="`${largeProcessType.name}実行予定日(終了)`"
										:rules="[rules.required]"
										v-model="scheduleArrangementPlannedEndDate"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker
									v-model="scheduleArrangementPlannedEndDate"
									no-title
									scrollable
									locale="ja"
								/>
							</v-menu>
						</v-col>

						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-text-field
								v-model="scheduleArrangementPlannedEndTime"
								:label="`${largeProcessType.name}実行予定時間(終了)`"
								:rules="[rules.required]"
								class="mt-4"
								type="time"
								step="1800"
								outlined
								dense
							/>
						</v-col>

						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="工程開始日"
										:rules="largeProcess.start_time ? [rules.required] : []"
										:hint="
											largeProcess.start_time
												? '工程開始時刻がある場合は日付も入力が必要です。'
												: ''
										"
										:persistent-hint="largeProcess.start_time != null && !largeProcess.start_date"
										v-model="largeProcess.start_date"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker v-model="largeProcess.start_date" no-title scrollable locale="ja" />
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-text-field
								v-model="largeProcess.start_time"
								label="工程開始時刻"
								class="mt-4"
								type="time"
								step="1800"
								outlined
								dense
							/>
						</v-col>
						<v-col cols="12" sm="6" class="pr-sm-1">
							<v-menu
								ref="menu"
								:close-on-content-click="false"
								close-on-click
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="工程完了日"
										:rules="largeProcess.end_time ? [rules.required] : []"
										:hint="
											largeProcess.end_time ? '工程完了時刻がある場合は日付も入力が必要です。' : ''
										"
										:persistent-hint="largeProcess.end_time != null && !largeProcess.end_date"
										v-model="largeProcess.end_date"
										outlined
										dense
										readonly
										v-bind="attrs"
										v-on="on"
										class="mt-4"
									/>
								</template>
								<v-date-picker v-model="largeProcess.end_date" no-title scrollable locale="ja" />
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" class="pl-sm-1">
							<v-text-field
								v-model="largeProcess.end_time"
								label="工程完了時刻"
								class="mt-4"
								type="time"
								step="1800"
								outlined
								dense
							/>
						</v-col>
					</v-row>
				</template>

				<v-row justify="center" no-gutters>
					<v-btn color="secondary" @click="submitForm()">
						<v-icon class="mr-1">mdi-content-save</v-icon>
						変更する
					</v-btn>
				</v-row>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import _ from "lodash"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import moment from "moment/min/moment.min.js"

export default {
	props: {
		large_process: {
			type: null,
			required: false,
		},
		maxWidth: {
			type: String,
			default: "700px",
			required: false,
		},
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			rules: rules,
			common: common,
			valid: false,
			largeProcess: {
				start_date: null,
				end_date: null,
				start_time: null,
				end_time: null,
				planned_start_date: null,
				planned_end_date: null,
				planned_start_time: null,
				planned_end_time: null,
				schedule_start_date: null,
				schedule_end_date: null,
				schedule_start_time: null,
				schedule_end_time: null,
				schedule_arrangement: {},
			},
			scheduleArrangementEstimatedStartDate: null,
			scheduleArrangementEstimatedEndDate: null,
			scheduleArrangementPlannedStartDate: null,
			scheduleArrangementPlannedEndDate: null,
			scheduleArrangementPlannedStartTime: null,
			scheduleArrangementPlannedEndTime: null,
			largeProcessType: {},
		}
	},
	methods: {
		closeDialog() {
			this.showDialog = false
		},
		submitForm() {
			let largeProcess = this.largeProcess
			largeProcess.start_time = largeProcess.start_time
				? `2000-01-01 ${largeProcess.start_time}:00`
				: null
			largeProcess.end_time = largeProcess.end_time
				? `2000-01-01 ${largeProcess.end_time}:00`
				: null
			largeProcess.planned_start_time = largeProcess.planned_start_time
				? `2000-01-01 ${largeProcess.planned_start_time}:00`
				: null
			largeProcess.planned_end_time = largeProcess.planned_end_time
				? `2000-01-01 ${largeProcess.planned_end_time}:00`
				: null
			largeProcess.schedule_start_time = largeProcess.schedule_start_time
				? `2000-01-01 ${largeProcess.schedule_start_time}:00`
				: null
			largeProcess.schedule_end_time = largeProcess.schedule_end_time
				? `2000-01-01 ${largeProcess.schedule_end_time}:00`
				: null
				console.log(largeProcess)
			this.$emit("update-large-process", largeProcess)
			this.closeDialog()
		},
		setProcess(largeProcess) {
			let newLargeProcess = _.cloneDeep(largeProcess)
			newLargeProcess.large_process_values_attributes = newLargeProcess.large_process_values.map(
				(v) => {
					if (v.value_time) {
						v.value_time = moment(v.value_time).format("HH:mm")
					}
					return v
				}
			)
			if (this.largeProcessType.schedule_arrangement_flag) {
				newLargeProcess.start_time = largeProcess.start_time
					? moment(largeProcess.start_time).format("HH:mm")
					: null
				newLargeProcess.end_time = largeProcess.end_time
					? moment(largeProcess.end_time).format("HH:mm")
					: null
				this.setScheduleArrangement(newLargeProcess)
			} else {
				newLargeProcess.start_time = largeProcess.start_time
					? moment(largeProcess.start_time).format("HH:mm")
					: null
				newLargeProcess.end_time = largeProcess.end_time
					? moment(largeProcess.end_time).format("HH:mm")
					: null
				newLargeProcess.planned_start_time = largeProcess.planned_start_time
					? moment(largeProcess.planned_start_time).format("HH:mm")
					: null
				newLargeProcess.planned_end_time = largeProcess.planned_end_time
					? moment(largeProcess.planned_end_time).format("HH:mm")
					: null
				newLargeProcess.schedule_start_time = largeProcess.schedule_start_time
					? moment(largeProcess.schedule_start_time).format("HH:mm")
					: null
				newLargeProcess.schedule_end_time = largeProcess.schedule_end_time
					? moment(largeProcess.schedule_end_time).format("HH:mm")
					: null
			}
			return newLargeProcess
		},
		setScheduleArrangement(process) {
			this.scheduleArrangementEstimatedStartDate = process.schedule_arrangement.estimated_start_date
			this.scheduleArrangementEstimatedEndDate = process.schedule_arrangement.estimated_end_date
			this.scheduleArrangementPlannedStartDate = process.schedule_arrangement.planned_start_time
				? moment(process.schedule_arrangement.planned_start_time).format("YYYY-MM-DD")
				: null
			this.scheduleArrangementPlannedEndDate = process.schedule_arrangement.planned_end_time
				? moment(process.schedule_arrangement.planned_end_time).format("YYYY-MM-DD")
				: null
			this.scheduleArrangementPlannedStartTime = process.schedule_arrangement.planned_start_time
				? moment(process.schedule_arrangement.planned_start_time).format("HH:mm")
				: null
			this.scheduleArrangementPlannedEndTime = process.schedule_arrangement.planned_end_time
				? moment(process.schedule_arrangement.planned_end_time).format("HH:mm")
				: null
		},
	},
	watch: {
		large_process(newVal, _) {
			this.largeProcessType = newVal.large_process_type
			this.largeProcess = this.setProcess(newVal)
		},
		scheduleArrangementPlannedStartDate(newVal, _) {
			if (this.scheduleArrangementPlannedStartTime && newVal) {
				this.largeProcess.schedule_arrangement.planned_start_time = `${newVal} ${this.scheduleArrangementPlannedStartTime}`
			} else {
				this.largeProcess.schedule_arrangement.planned_start_time = null
			}
		},
		scheduleArrangementPlannedEndDate(newVal, _) {
			if (this.scheduleArrangementPlannedEndTime && newVal) {
				this.largeProcess.schedule_arrangement.planned_end_time = `${newVal} ${this.scheduleArrangementPlannedEndTime}`
			} else {
				this.largeProcess.schedule_arrangement.planned_end_time = null
			}
		},
		scheduleArrangementPlannedStartTime(newVal, _) {
			if (this.scheduleArrangementPlannedStartDate && newVal) {
				this.largeProcess.schedule_arrangement.planned_start_time = `${this.scheduleArrangementPlannedStartDate} ${newVal}`
			} else {
				this.largeProcess.schedule_arrangement.planned_start_time = null
			}
		},
		scheduleArrangementPlannedEndTime(newVal, _) {
			if (this.scheduleArrangementPlannedEndDate && newVal) {
				this.largeProcess.schedule_arrangement.planned_end_time = `${this.scheduleArrangementPlannedEndDate} ${newVal}`
			} else {
				this.largeProcess.schedule_arrangement.planned_end_time = null
			}
		},
		scheduleArrangementEstimatedStartDate(newVal) {
			this.largeProcess.schedule_arrangement.estimated_start_date = newVal
		},
		scheduleArrangementEstimatedEndDate(newVal) {
			this.largeProcess.schedule_arrangement.estimated_end_date = newVal
		},

		deep: true,
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>